const appEvents = {
  start: 'app/modules/common/service/app/start',
  outdated: 'app/modules/common/service/app/outdated',
  session: {
    start: 'app/modules/common/services/appSession/start',
    change: 'app/modules/common/services/appSession/change',
    unauthorized: 'app/modules/common/services/appSession/unauthorized',
    end: 'app/modules/common/services/appSession/end',
  },
  createUser: {
    open: 'app/modules/common/services/createUser/open',
    close: 'app/modules/common/services/createUser/close',
    save: 'app/modules/common/services/createUser/save',
    reactivate: 'app/modules/common/services/createUser/reactivate',
    import: 'app/modules/common/services/createUser/import',
  },
  settings: {
    open: 'app/modules/common/services/settings/open',
    close: 'app/modules/common/services/settings/close',
    save: 'app/modules/common/services/settings/save',
  },
};

export default appEvents;
